module.exports = __webpack_public_path__ + "static/media/brand-firehub-default.9f66898a.svg";